/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-view-off': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M3.275 14.069l.894-.888A8.788 8.788 0 011.919 10C3.187 6.831 6.687 4.375 10 4.375a7.738 7.738 0 012.5.45l.969-.975A9.2 9.2 0 0010 3.125 10.431 10.431 0 00.662 9.787a.625.625 0 000 .425 10 10 0 002.613 3.857zM7.5 9.83a2.5 2.5 0 012.313-2.31l1.13-1.138a3.75 3.75 0 00-4.58 4.582L7.5 9.83zm11.837-.043a10.25 10.25 0 00-3.587-4.65l3-3.007-.881-.881L1.25 17.869l.881.881 3.188-3.188A9.556 9.556 0 0010 16.875a10.431 10.431 0 009.337-6.662.625.625 0 000-.425zM12.5 10a2.5 2.5 0 01-3.75 2.15l3.4-3.4A2.5 2.5 0 0112.5 10zM10 15.625a8.156 8.156 0 01-3.75-.988l1.588-1.587a3.75 3.75 0 005.218-5.219l1.794-1.794A9.087 9.087 0 0118.081 10c-1.268 3.169-4.768 5.625-8.081 5.625z"/>'
  }
})
